//
//
//
//
//
//
import d2DemoArticle from './components/d2-demo-article';
export default {
  components: {
    'd2-demo-article': d2DemoArticle
  }
};